import { render } from "./TaskManager.vue?vue&type=template&id=3f6cfafc&ts=true"
import script from "./TaskManager.ts?vue&type=script&lang=ts&external"
export * from "./TaskManager.ts?vue&type=script&lang=ts&external"

import "./TaskManager.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__